import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router-dom";
import { withStyles, withTheme } from "@material-ui/core/styles";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarHalfIcon from "@material-ui/icons/StarHalf";
import axios from "../../AxiosClient";
import { Trans, withTranslation } from "react-i18next";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { Badge, Tooltip } from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import DisplayUser from "../user/DisplayUser";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

const styles = (theme) => ({
  score: {
    marginLeft: "auto",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    display: "flex",
  },
  viewed: {
    marginRight: theme.spacing(3),
  },
  smallIcon: {
    fontSize: 18,
    color: theme.palette.secondary.dark,
  },
  linkedDoc: { 
    marginLeft: theme.spacing(3), 
    verticalAlign: "middle", 
    color: theme.palette.primary.dark, 
  }
});
export class SearchItem extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    extendedString: "",
    itemData: [],
  };

  componentDidMount() {
    // this.extendedInfo(this.props.settings);
    let url = `/document/${this.props.data.documentId}`;
    let params = {
      displayDraft: false,
    };
    axios
      .get(url, {
        params,
      })
      .then((res) => {
        this.setState({ itemData: res.data });
        this.extendedInfo(this.props.settings);
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.settings !== this.props.settings) {
      this.extendedInfo(this.props.settings);
    }
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <div>
        <KpsListItem
          extendedString={this.state.extendedString}
          preText={this.props.preText}
          provided={this.props.provided}
          onItemClick={this.onItemClick}
        >
          {this.props.preText}
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={
              this.state.itemData.used === true || this.props.data.used === true || this.props.data.hasOwnProperty("resolutionId") ? (
                <div style={{ display: "flex" }}>
                  <div>{this.state.itemData.userTitle}</div>
                  <div className={classes.linkedDoc}>
                    <LinkIcon />
                  </div>
                </div>
              ) : (
                this.state.itemData.userTitle
              )
            }
            secondary={this.secondaryInfo()}
          />
        </KpsListItem>
      </div>
    );
  }
  getResultScore = (score) => {
    let stars = [];
    let adjusted = Math.floor((score * 100) / 20);
    let remainder = (score * 100) / 20 - adjusted;
    let remainingStars = 5 - adjusted;
    var i = 0;
    for (i; i < adjusted; i++) {
      stars.push(<StarIcon key={i} className={this.props.classes.smallIcon} />);
    }

    if (remainder > 0.24 && remainder < 0.76) {
      stars.push(
        <StarHalfIcon key={i++} className={this.props.classes.smallIcon} />
      );
      remainingStars--;
    } else if (remainder >= 0.76) {
      stars.push(
        <StarIcon key={i++} className={this.props.classes.smallIcon} />
      );
      remainingStars--;
    }

    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <StarBorderIcon key={i + 5} className={this.props.classes.smallIcon} />
      );
    }
    return stars;
  };
  extendedInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.documentOptions.length; i++) {
        settings.push({ label: this.props.documentOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <>
              {(setting.label !== "settings_document_rework_count" ||
                this.props.currentUser.userPermits.roles.beExpert) && (
                <TableRow>
                  <TableCell>{this.props.t(setting.label)}</TableCell>
                  {this.getSettingInfo(setting)}
                </TableRow>
              )}
            </>
          );
        })}
      </>
    );
    this.setState({ extendedString: extendedString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_document_revalidation_date" && (
          <TableCell>
            {!!this.state.itemData.revalidationDate
              ? moment(this.state.itemData.revalidationDate).format("LL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_created_date" && (
          <TableCell>
            {!!this.state.itemData.dateCreated
              ? moment(this.state.itemData.dateCreated).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_last_date_modified" && (
          <TableCell>
            {!!this.state.itemData.dateModified
              ? moment(this.state.itemData.dateModified).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_liked" && (
          <TableCell>
            {this.state.itemData.likedCount}
            {this.state.itemData.likedCount > 0 &&
              this.state.itemData.likedRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.state.itemData.likedRanking +
                          " " +
                          this.props.t("global_most_liked")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.state.itemData.likedRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_favourited" && (
          <TableCell>
            {this.state.itemData.favouritedCount}
            {this.state.itemData.favouritedCount > 0 &&
              this.state.itemData.favouriteRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.state.itemData.favouriteRanking +
                          " " +
                          this.props.t("global_most_favourited")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.state.itemData.favouriteRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_viewed" && (
          <TableCell>
            {this.state.itemData.viewedCount}
            {this.state.itemData.viewedCount > 0 &&
              this.state.itemData.viewedRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.state.itemData.viewedRanking +
                          " " +
                          this.props.t("global_most_viewed")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.state.itemData.viewedRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_used" && (
          <TableCell>
            {this.state.itemData.usedCount}
            {this.state.itemData.usedCount > 0 &&
              this.state.itemData.usageRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.state.itemData.usageRanking +
                          " " +
                          this.props.t("global_most_used")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.state.itemData.usageRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_date_last_viewed_by_me" && (
          <TableCell>
            {!!this.state.itemData.myLastViewed
              ? moment(this.state.itemData.myLastViewed).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_user_who_last_modified" &&
        this.state.itemData.isKnowledgeItem === true ? (
          <TableCell>
            <DisplayUser
              userId={
                this.state.itemData.lastModifiedByUser
                  ? this.state.itemData.lastModifiedByUser.userId
                  : ""
              }
              user={this.state.itemData.lastModifiedByUser}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_user_who_last_modified" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
        {this.props.currentUser.userPermits.roles.beExpert && (
          <>
            {setting.label === "settings_document_rework_count" &&
            this.state.itemData.canMarkForRework &&
            this.state.itemData.isKnowledgeItem === true ? (
              <TableCell>{this.state.itemData.reworkCount}</TableCell>
            ) : (
              setting.label === "settings_document_rework_count" && (
                <TableCell>{this.props.t("global_not_applicable")}</TableCell>
              )
            )}
          </>
        )}
        {setting.label === "settings_document_author" &&
        this.state.itemData.isKnowledgeItem === true ? (
          <TableCell>
            <DisplayUser
              userId={
                this.state.itemData.author
                  ? this.state.itemData.author.userId
                  : ""
              }
              user={this.state.itemData.author}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_author" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
        {setting.label === "settings_document_live_revision_author" &&
        this.state.itemData.isKnowledgeItem === true ? (
          <TableCell>
            {/* <DisplayUser userId={this.state.itemData.author} /> */}
            <DisplayUser
              userId={
                this.state.itemData.liveRevisionAuthor
                  ? this.state.itemData.liveRevisionAuthor.userId
                  : ""
              }
              user={this.state.itemData.liveRevisionAuthor}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_live_revision_author" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
      </>
    );
  };

  // extendedInfo(settings) {
  //   if (!settings) {
  //     settings = [];
  //     for (let i = 0; i < this.props.documentOptions.length; i++) {
  //       settings.push({ label: this.props.documentOptions[i], order: i });
  //     }
  //   } else {
  //     settings = typeof settings !== "object" && JSON.parse(settings);
  //   }
  //   var extendedString = (
  //     <>
  //       {settings.map((setting, idx) => {
  //         return (
  //           <TableRow key={idx}>
  //             <TableCell>{this.props.t(setting.label)}</TableCell>
  //             {setting.label === "settings_document_last_date_modified" && (
  //               <TableCell>{this.state.itemData.dateModified}</TableCell>
  //             )}
  //             {setting.label === "settings_document_number_of_liked" && (
  //               <TableCell>
  //                 {this.state.itemData.likedCount}
  //                 {this.state.itemData.likedCount > 0 &&
  //                   this.state.itemData.likedRanking > 0 && (
  //                     <span style={{ marginLeft: "10px" }}>
  //                       <Tooltip
  //                         title={
  //                           this.props.t("global_ranked") +
  //                           " " +
  //                           this.state.itemData.likedRanking +
  //                           " " +
  //                           this.props.t("global_most_liked")
  //                         }
  //                       >
  //                         <Badge>
  //                           <span
  //                             style={{ fontSize: "1.4em", marginRight: "3px" }}
  //                             className="mdi mdi-trophy-outline"
  //                           />
  //                           {this.state.itemData.likedRanking}
  //                         </Badge>
  //                       </Tooltip>
  //                     </span>
  //                   )}
  //               </TableCell>
  //             )}
  //             {setting.label ===
  //               "settings_document_number_of_times_favourited" && (
  //               <TableCell>
  //                 {this.state.itemData.favouritedCount}
  //                 {this.state.itemData.favouritedCount > 0 &&
  //                   this.state.itemData.favouriteRanking > 0 && (
  //                     <span style={{ marginLeft: "10px" }}>
  //                       <Tooltip
  //                         title={
  //                           this.props.t("global_ranked") +
  //                           " " +
  //                           this.state.itemData.favouriteRanking +
  //                           " " +
  //                           this.props.t("global_most_favourited")
  //                         }
  //                       >
  //                         <Badge>
  //                           <span
  //                             style={{ fontSize: "1.4em", marginRight: "3px" }}
  //                             className="mdi mdi-trophy-outline"
  //                           />
  //                           {this.state.itemData.favouriteRanking}
  //                         </Badge>
  //                       </Tooltip>
  //                     </span>
  //                   )}
  //               </TableCell>
  //             )}
  //             {setting.label === "settings_document_number_of_times_viewed" && (
  //               <TableCell>
  //                 {this.state.itemData.viewedCount}
  //                 {this.state.itemData.viewedCount > 0 &&
  //                   this.state.itemData.viewedRanking > 0 && (
  //                     <span style={{ marginLeft: "10px" }}>
  //                       <Tooltip
  //                         title={
  //                           this.props.t("global_ranked") +
  //                           " " +
  //                           this.state.itemData.viewedRanking +
  //                           " " +
  //                           this.props.t("global_most_viewed")
  //                         }
  //                       >
  //                         <Badge>
  //                           <span
  //                             style={{ fontSize: "1.4em", marginRight: "3px" }}
  //                             className="mdi mdi-trophy-outline"
  //                           />
  //                           {this.state.itemData.viewedRanking}
  //                         </Badge>
  //                       </Tooltip>
  //                     </span>
  //                   )}
  //               </TableCell>
  //             )}
  //             {setting.label === "settings_document_number_of_times_used" && (
  //               <TableCell>
  //                 {this.state.itemData.usedCount}
  //                 {this.state.itemData.usedCount > 0 &&
  //                   this.state.itemData.usageRanking > 0 && (
  //                     <span style={{ marginLeft: "10px" }}>
  //                       <Tooltip
  //                         title={
  //                           this.props.t("global_ranked") +
  //                           " " +
  //                           this.state.itemData.usageRanking +
  //                           " " +
  //                           this.props.t("global_most_used")
  //                         }
  //                       >
  //                         <Badge>
  //                           <span
  //                             style={{ fontSize: "1.4em", marginRight: "3px" }}
  //                             className="mdi mdi-trophy-outline"
  //                           />
  //                           {this.state.itemData.usageRanking}
  //                         </Badge>
  //                       </Tooltip>
  //                     </span>
  //                   )}
  //               </TableCell>
  //             )}
  //             {setting.label === "settings_document_date_last_viewed_by_me" && (
  //               <TableCell>{this.state.itemData.myLastViewed}</TableCell>
  //             )}
  //             {setting.label === "settings_document_user_who_last_modified" &&
  //             this.state.itemData.isKnowledgeItem === true ? (
  //               <TableCell>
  //                 {this.state.itemData.lastModifiedByUserString}
  //               </TableCell>
  //             ) : (
  //               setting.label ===
  //                 "settings_document_user_who_last_modified" && (
  //                 <TableCell>{this.props.t("global_not_applicable")}</TableCell>
  //               )
  //             )}
  //             {setting.label === "settings_document_rework_count" &&
  //             this.state.itemData.canMarkForRework &&
  //             this.state.itemData.isKnowledgeItem === true ? (
  //               <TableCell>{this.state.itemData.reworkCount}</TableCell>
  //             ) : (
  //               setting.label === "settings_document_rework_count" && (
  //                 <TableCell>{this.props.t("global_not_applicable")}</TableCell>
  //               )
  //             )}
  //             {setting.label === "settings_document_author" &&
  //             this.state.itemData.isKnowledgeItem === true ? (
  //               <TableCell>
  //                 <DisplayUser
  //                     userId={
  //                       this.state.itemData.author ? this.state.itemData.author.userId : ""
  //                     }
  //                     user={this.state.itemData.author}
  //                   />
  //               </TableCell>
  //             ) : (
  //               setting.label === "settings_document_author" && (
  //                 <TableCell>{this.props.t("global_not_applicable")}</TableCell>
  //               )
  //             )}
  //           </TableRow>
  //         );
  //       })}
  //     </>
  //   );
  //   this.setState({ extendedString });
  // }

  onItemClick = (e) => {
    this.props.history.push(`/full/document/${this.props.data.documentId}`);
  };

  secondaryInfo = (settings) => {
    const { classes, theme } = this.props;
    return (
      <div style={{ display: "flex", verticalAlign: "middle" }}>
        <div>
          <span className={this.props.classes.viewed}>
            <>{this.props.t("settings_document_number_of_times_viewed")}</> :{" "}
            <strong>{this.props.data.times}</strong>
          </span>
          <span>
            <>{this.props.t("position")}</> :{" "}
            <strong>{this.props.data.resultPosition}</strong>
          </span>
        </div>
        <div className={this.props.classes.score}>
          <div>{this.getResultScore(this.props.data.score)}</div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  settings: state.setting.searchSettings,
  documentSettings: state.setting.documentSettings,
  documentOptions: state.selectionOption.documentSettingsOptions,
  currentUser: state.user.currentUser,
});

export default connect(
  mapStateToProps,
  null
)(withRouter(withTheme(withStyles(styles)(withTranslation()(SearchItem)))));
